import request from "@/utils/request";

// 创建推荐书目
export const createBook = (data) => {
    return request({
        url: "/businessservice/book/create",
        method: "post",
        data: data
    })
}

// 更新推荐书目
export const updateBook = (data) => {
    return request({
        url: "/businessservice/book/update",
        method: "post",
        data: data
    })
}

// 分页查询推荐书目
export const pageBook = (data) => {
    return request({
        url: "/businessservice/book/page",
        method: "post",
        data: data
    })
}

// 列表查询推荐书目
export const listBook = (data) => {
    return request({
        url: "/businessservice/book/list",
        method: "post",
        data: data
    })
}

// 查询推荐书目信息
export const  infoBook =(query) =>{
    return request({
        url: "/businessservice/book/info",
        method:"get",
        params: query
    })
}

// 删除推荐书目信息
export const  deleteBook =(query) =>{
    return request({
        url: "/businessservice/book/delete",
        method:"get",
        params: query
    })
}

